import { useTheme } from '@emotion/react'
import { AllEvents, click_origin_breach_screen } from '@news-mono/web-common'
import React, { useMemo } from 'react'
import { PuzzleListingDescription } from '../../puzzles/PuzzleListing/TheWest/PuzzleListing.styled'
import { useAuthActions } from '../../user-registration'
import { PuzzlesListingCards } from '../../user-registration/breach/components/PuzzlesBreach/PuzzlesListingCards'
import { createLinkClickEvent } from '../../user-registration/breach/createLinkClickHandler'
import {
    BottomTextWrap,
    ButtonWrap,
    CTAHeading,
    CTASubHeading,
    InfoText,
    InfoTextLink,
    PuzzlesBreachCTAWrap,
    PuzzlesBreachWrap,
    SubscribeButton,
} from './PuzzlesPage.styled'

const puzzlesBackgroundImage = require('./assets/puzzle-tw-min.png')

export type PuzzlesPageProps = {
    onEvent: (event: AllEvents) => void
    title: string
    bannerMessage?: string
    message?: string
    renditionType?: string
}

export const PuzzlesPage = ({
    onEvent,
    title,
    bannerMessage: bannerText,
    message,
    renditionType,
}: PuzzlesPageProps) => {
    const theme = useTheme()
    const { onLoginClick, getSubscribeLink } = useAuthActions()
    const subscriptionUrl = useMemo(
        () =>
            getSubscribeLink({
                callToAction: click_origin_breach_screen,
                breachScreenType: 'Premium - Inline',
            }),
        [getSubscribeLink],
    )

    // handle whenever 'subscription options' is clicked.
    const onAllPackagesClicked = React.useCallback(() => {
        createLinkClickEvent('Puzzles', 'Puzzles', onEvent)()
    }, [onEvent])

    return (
        <PuzzlesBreachWrap theme={theme}>
            {renditionType !== 'app' && bannerText && (
                <PuzzleListingDescription>
                    {bannerText}
                </PuzzleListingDescription>
            )}
            <PuzzlesBreachCTAWrap
                bgImage={puzzlesBackgroundImage}
                noBanner={!bannerText}
            >
                <CTAHeading>{title}</CTAHeading>
                <CTASubHeading>{message}</CTASubHeading>
                <ButtonWrap>
                    <SubscribeButton to={'/puzzles/subscribe'}>
                        Subscribe
                    </SubscribeButton>
                </ButtonWrap>
                <BottomTextWrap>
                    <InfoText>
                        Looking for a different subscription?{' '}
                        <InfoTextLink
                            href={subscriptionUrl}
                            onEvent={onAllPackagesClicked}
                        >
                            Browse all
                        </InfoTextLink>
                    </InfoText>
                    <InfoText>
                        Already have an account?{' '}
                        <InfoTextLink
                            href={'#'}
                            onEvent={() => onLoginClick('puzzles-cta')}
                        >
                            Log in here
                        </InfoTextLink>
                    </InfoText>
                </BottomTextWrap>
            </PuzzlesBreachCTAWrap>

            <PuzzlesListingCards disabled={true} />
        </PuzzlesBreachWrap>
    )
}
